export default __webpack_public_path__ + "static/media/drug.a1ee2ccd.png";